// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"1f17e406774f6b190e40","303":"1e13b664afd1e1ebe129","495":"a1d218ff498c4d09f547"}[chunkId] + ".js";
};